module.exports = __webpack_public_path__ + "assets/img/BnBerry-Landing-Page-+-Website-w960.fa81fb93.webp";